import { Card } from 'mga-commons';
import React from 'react';
import { Link } from 'react-router-dom';
import './CardAccueil.css';

const renderItems = (items) => {
    return items.map(function (item, index) {
        return (
            <li title={item.libelle} key={index}><Link to={item.url}>{item.libelle}</Link></li>
        )
    })
}

export const CardAccueil = ({ imgSrc, alt, title, items }) => {
    return (
        <Card margin="20px 10px" padding="10px 10px">
            <div className="card-accueil">
                <div className="header">
                    <img loading="lazy" src={imgSrc} alt={alt} />
                    <span>{title}</span>
                </div>
                <ul className="content">
                    {renderItems(items)}
                </ul>
            </div>
        </Card>
    )
}

export default CardAccueil
